import { Component } from '@angular/core';
import { StaffAdminVerifyService } from '../../services/staff-admin-verify.service';

// Single shared instance of the mobile+password re-verification modal —
// mount it once (in the staff layout, which wraps every staff page) and any
// component can trigger it via StaffAdminVerifyService.requestVerification().
@Component({
    selector: 'app-staff-admin-verify-modal',
    templateUrl: './staff-admin-verify-modal.component.html',
    styleUrls: ['../staff-common.css', './staff-admin-verify-modal.component.css']
})
export class StaffAdminVerifyModalComponent {
    constructor(public verify: StaffAdminVerifyService) {}
}
